import axios from "axios";
import { EquipmentImageResponse } from "../../../types/model/warehouse/equipmentImage";
import { SessionStore } from "../../../types/store";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/warehouse/equipment`;

export const getEquipmentImageById = async (
  equipmentId: number,
  imageId: number,
): Promise<EquipmentImageResponse> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.get<EquipmentImageResponse>(
    `${BASE_URL}/${equipmentId}/images/${imageId}`,
    {
      headers: {
        "x-access-token": session?.accessToken,
      },
      responseType: "blob",
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  return res.data;
};